import React from 'react';
import restService from 'RestService'; // Adjust path if needed
import { ObjectWrapper } from './styles/Common.styles';
import { StyledImage } from './styles/Picture.styles';

const PictureControl = ({ control }) => {
  const imageUrl = control.assetId ? restService.getAssetURL(control.assetId) : null;

  return (
    <ObjectWrapper>
      {imageUrl ? (
        <StyledImage
          src={imageUrl}
          stretch={control.stretch}
          maintainAspectRatio={control.maintainAspectRatio}
          alt={control.label}
        />
      ) : (
        <div style={{ border: '1px dashed #ccc', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: '#999' }}>
          No Image
        </div>
      )}
    </ObjectWrapper>
  );
};

export default PictureControl;